module.exports = __webpack_public_path__ + "img/petrol_china_logo.ef21e783.png";